import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useUserRoles } from '@/hooks/useUserRoles';

export function useAdminPendingCount() {
  const { isAdmin } = useUserRoles();

  const { data: pendingCount = 0 } = useQuery({
    queryKey: ['adminPendingCount'],
    queryFn: async () => {
      const [profiles, planRequests, payments] = await Promise.all([
        supabase.from('profiles').select('*', { count: 'exact', head: true }).eq('status', 'pending'),
        supabase.from('plan_change_requests').select('*', { count: 'exact', head: true }).eq('status', 'pending'),
        supabase.from('course_payments').select('*', { count: 'exact', head: true }).eq('status', 'pending'),
      ]);
      return (profiles.count || 0) + (planRequests.count || 0) + (payments.count || 0);
    },
    enabled: isAdmin,
    refetchInterval: 30000,
    staleTime: 15000,
  });

  return { pendingCount, isAdmin };
}
